<template>
  <div id="calendar-day">
    <calendarYear :selectingYear="selectingYear"
                  :setSelectYear="setSelectYear"
                  :currentYear="currentYear"
                  :disableCalendarYearButton="disableCalendarYearButton" />
    <!-- Section Month -->
    <ul class="month">
      <li v-for="index in 12" :id="index"
          :class="{ 'current-month' : index == selectingMonth }" class="month-text" v-on:click="setSelectMonth(index)">
          {{ month[nowLang][index-1].short }}
          <i :class="{ 'fa fa-star star-month' : checkCalendarMain(0, index) }"></i>
      </li>
    </ul>
    <!-- Section Weekdays -->
    <div class="table-calendar">
      <table class="table table-bordered" align="center" id="calendar-date">
        <thead class="weekdays">
          <tr>
            <th v-for="index_day in 7"
                :id="index_day">
                {{ days[nowLang][index_day - 1] }}
            </th>
          </tr>
        </thead>
        <template v-if="disableCalendarYearButton">
          <div class="infinite-loading-container icon-load"><i class="loading-default"></i></div>
        </template>
        <template v-else>
          <!-- Section days -->
          <tbody class="days">
            <template v-for="week in totalWeek">
              <week-row :arrWeek="calArrWeek(week)"
                        :setSelectDate="setSelectDate"
                        :checkCurrentDay="checkCurrentDay"
                        :checkSelectedDay="checkSelectedDay"
                        :checkCalendarMain="checkCalendarMain"
                        :checkCalendarHoliday="checkCalendarHoliday"
                        :pcDisp="pcDisp"
                        :autoFocusCalendarTab="autoFocusCalendarTab"
                        :calendarTab1="calendarTab1"
                        :calendarTab2="calendarTab2"
                        :calendarTab3="calendarTab3"
                        :calendarTab4="calendarTab4"/>
            </template>
          </tbody>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import weekRow from 'components/calendar/weekRow'
import calendarYear from 'components/calendar/calendar_year'

export default {
  name: 'mode_day',
  props: [ 'currentYear', 'selectingMonth', 'selectingYear', 'setSelectYear', 'setSelectDate', 'setSelectMonth', 'totalWeek', 'days', 'month', 'checkCalendarMain', 'calArrWeek', 'checkCurrentDay', 'checkSelectedDay', 'pcDisp', 'nowLang', 'disableCalendarYearButton', 'autoFocusCalendarTab', 'calendarTab1', 'calendarTab2', 'calendarTab3', 'calendarTab4', 'checkCalendarHoliday' ],
  components: {
    weekRow,
    calendarYear
  }
}
</script>



// WEBPACK FOOTER //
// mode_day.vue?0e718944